/* eslint-disable react/no-array-index-key */
import React, { ReactNode, useState } from "react";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { Description } from "@mui/icons-material";
import { Box, IconButton, SxProps, Tooltip, Typography } from "@mui/material";

import Panel from "../../../components/Panel";
import { t } from "../../../components/translate";
import { capitalizeWords } from "../../../helpers/util";
import useReportList from "../../../hooks/useReportList";

interface PropTypes {
  module: string;
  sxProps?: SxProps;
  showListedReports?: Array<string>;
}

export default function ReportsPanel({
  module,
  sxProps,
  showListedReports = []
}: PropTypes): ReactNode {
  const dispatch = useDispatch();
  const reports = useReportList();

  const [openReport, setOpenReport] = useState(false);

  let selectedModuleReports = reports[module].filter((report) => report.can);

  if (showListedReports.length > 0) {
    selectedModuleReports = selectedModuleReports.filter((report) =>
      showListedReports.includes(report.name)
    );
  }

  return (
    <>
      <Tooltip arrow title={`${t("reports.reports")}`}>
        <IconButton
          onClick={() => setOpenReport(true)}
          sx={{
            width: 32,
            height: 32,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            ...sxProps
          }}
        >
          <Description color="action" sx={{ height: "18px", width: "18px" }} />
        </IconButton>
      </Tooltip>

      {openReport && (
        <Panel
          onClose={() => setOpenReport(false)}
          title={`${capitalizeWords(module)} Reports`}
          wrapperStyle={{ minWidth: "600px", ...sxProps }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              width: "100%"
            }}
          >
            {selectedModuleReports?.length > 0 ? (
              selectedModuleReports.map((report, index) => (
                <Box key={index} onClick={() => dispatch(push(report.path))}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1.5,
                      padding: 1.5,
                      border: "1px solid #e0e0e0",
                      borderRadius: "4px",
                      cursor: "pointer",
                      ":hover": {
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
                      }
                    }}
                  >
                    <Typography sx={{ pt: "2px" }} component="span">
                      {report?.icon}
                    </Typography>
                    <Box>
                      <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
                        {report?.label}
                      </Typography>
                      <Typography sx={{ fontSize: "14px", fontWeight: 400, color: "#888" }}>
                        {report?.description}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))
            ) : (
              <Box>No reports available</Box>
            )}
          </Box>
        </Panel>
      )}
    </>
  );
}
